/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UnitEconomicsUserRow interface.
 */
export function instanceOfUnitEconomicsUserRow(value) {
    if (!('costUsd' in value) || value['costUsd'] === undefined)
        return false;
    if (!('generations' in value) || value['generations'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('tokensIn' in value) || value['tokensIn'] === undefined)
        return false;
    if (!('tokensOut' in value) || value['tokensOut'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    return true;
}
export function UnitEconomicsUserRowFromJSON(json) {
    return UnitEconomicsUserRowFromJSONTyped(json, false);
}
export function UnitEconomicsUserRowFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'costUsd': json['costUsd'],
        'generations': json['generations'],
        'tier': json['tier'],
        'tokensIn': json['tokensIn'],
        'tokensOut': json['tokensOut'],
        'userId': json['userId'],
    };
}
export function UnitEconomicsUserRowToJSON(json) {
    return UnitEconomicsUserRowToJSONTyped(json, false);
}
export function UnitEconomicsUserRowToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'costUsd': value['costUsd'],
        'generations': value['generations'],
        'tier': value['tier'],
        'tokensIn': value['tokensIn'],
        'tokensOut': value['tokensOut'],
        'userId': value['userId'],
    };
}
